function List() {
    return (
        <section className="screen screen_list">

            <div className="screen__title">
                <h1>
                    Portfolio | <a href="/pdf/Frants-Mitskun-CV.pdf" download="Frants Mitskun - CV">CV</a>
                </h1>
            </div>

            {/* Basketball */}
            <div className="card">
                <div className="card__background"></div>
                <a className="card__image-wrapper" href="https://superawesome.8thwall.app/spacejam/" target="_blank" rel="noreferrer">
                    <div className="card__image">
                        {/* <div className="card__image-placeholder"></div> */}
                        <img src="/img/portfolio/basket.png" alt="Space Jam Poster" />
                    </div>
                </a>
                <div className="card__content">
                    <a href="https://superawesome.8thwall.app/spacejam/" className="card__header" target="_blank" rel="noreferrer">Basketball AR Game</a>
                    <div className="card__meta">
                        <span className="card__date">Jun 2020 - Jul 2021</span>
                    </div>
                    <p className="card__paragraph">
                        Space Jam x Happy Meal<br />
                        Creating a mini-game for «Space Jam: A New Legacy» movie promo-company in Mcdonalds
                    </p>
                </div>
                <div className="card__extra-content">
                    <span>
                        A-Frame, Three.js, Hammer.js, Ammo.js
                    </span>
                </div>
            </div>

            {/* Retrowave */}
            <div className="card">
                <div className="card__background"></div>
                <a className="card__image-wrapper" href="https://frantsmn.github.io/retrowave/" target="_blank" rel="noreferrer">
                    <div className="card__image">
                        <div className="card__image-placeholder">Retrowave</div>
                        {/* <img src="/img/portfolio/basket.png" alt="Space Jam Poster" /> */}
                    </div>
                </a>
                <div className="card__content">
                    <a href="https://frantsmn.github.io/retrowave/" className="card__header" target="_blank" rel="noreferrer">Retrowave</a>
                    <div className="card__meta">
                        <span className="card__date">Jun 2021</span>
                    </div>
                    <p className="card__paragraph">
                        Three.js practice<br />
                        Audio frequencies animation, Post-effects
                    </p>
                </div>
                <div className="card__extra-content">
                    <span>
                        Three.js
                    </span>
                </div>
            </div>

            {/* Mask */}
            <div className="card">
                <div className="card__background"></div>
                <a className="card__image-wrapper" href="https://html.aaee.by/mask/index-timelapse" target="_blank" rel="noreferrer">
                    <div className="card__image">
                        {/* <div className="card__image-placeholder"></div> */}
                        <img src="/img/portfolio/mask.png" alt="Piece of puzzle" />
                    </div>
                </a>
                <div className="card__content">
                    <a href="https://html.aaee.by/mask/index-timelapse" className="card__header" target="_blank" rel="noreferrer">3D mask | Theatre-i.by</a>
                    <div className="card__meta">
                        <span className="card__date">Mar 2021</span>
                    </div>
                    <p className="card__paragraph">
                        Promo-page for theatrical premiere in case of Autism Awareness Day.<br />
                        Creating a section with the theatrical 3D mask. Coding animation (generative paths for puzzle pieces). Syncing animation for site visitors by WebSocket
                    </p>
                </div>
                <div className="card__extra-content">
                    <span>
                        JS (ES6+), Three.js, Less, Pug, Webpack, Prepros
                    </span>
                </div>
            </div>

            {/* EA Gallery Website */}
            <div className="card">
                <div className="card__background"></div>
                <a className="card__image-wrapper" href="https://ar.egorovagency.com/" target="_blank" rel="noreferrer">
                    <div className="card__image">
                        {/* <div className="card__image-placeholder"></div> */}
                        <img src="/img/portfolio/ea.png" alt="Egorov Agency logo" />
                    </div>
                </a>
                <div className="card__content">
                    <a href="https://ar.egorovagency.com/" className="card__header" target="_blank" rel="noreferrer">AR Portfolio | Egorovagency</a>
                    <div className="card__meta">
                        <span className="card__date">Nov 2020 - Feb 2021</span>
                    </div>
                    <p className="card__paragraph">
                        Gallery of models from projects with the use of augmented reality (WebAR).<br />
                        A large number of complex scroll animations, routing, i18n, GLB/GLTF rendering optimizations
                    </p>
                </div>
                <div className="card__extra-content">
                    <span>
                        JS(ES6+), Vue, Pug, Sass, Three.js, GSAP
                    </span>
                </div>
            </div>

            {/* Linia h2o */}
            <div className="card">
                <div className="card__background"></div>
                <a className="card__image-wrapper" href="https://vimeo.com/495492516" target="_blank" rel="noreferrer">
                    <div className="card__image">
                        {/* <div className="card__image-placeholder"></div> */}
                        <img src="/img/portfolio/linia.png" alt="LiniaH2O logo" />
                    </div>
                </a>
                <div className="card__content">
                    <a href="https://vimeo.com/495492516" className="card__header" target="_blank" rel="noreferrer">Kitchen Constructor | LiniaH2O</a>
                    <div className="card__meta">
                        <span className="card__date">Oct 2020 - Nov 2020</span>
                    </div>
                    <p className="card__paragraph">
                        3D kitchen constructor for the largest distributor of sanitary ware and other goods in Moldova
                    </p>
                </div>
                <div className="card__extra-content">
                    <span>
                        Three.js, ES6+, Vue/Vuex, Pug, Less
                    </span>
                </div>
            </div>

            {/* EA Website */}
            <div className="card">
                <div className="card__background"></div>
                <a className="card__image-wrapper" href="https://egorovagency.com/" target="_blank" rel="noreferrer">
                    <div className="card__image">
                        {/* <div className="card__image-placeholder">
                        DAROO
                    </div> */}
                        <img src="/img/portfolio/ea.png" alt="Egorov Agency logo" />
                    </div>
                </a>
                <div className="card__content">
                    <a href="https://egorovagency.com/" className="card__header" target="_blank" rel="noreferrer">Egorovagency</a>
                    <div className="card__meta">
                        <span className="card__date">Sep 2020 - Oct 2020</span>
                    </div>
                    <p className="card__paragraph">
                        Company website.<br />
                        Creating vue-components from Pug/Less layout, war with horizontal scroll, routing, dynamic content loading, saving data in localstorage, tweaking and optimizing app for Lighthouse, i18n, JSON-LD
                    </p>
                </div>
                <div className="card__extra-content">
                    <span>
                        Vue/Vuex, Pug, Less, Bootstrap
                    </span>
                </div>
            </div>

            {/* EA Webar Website */}
            <div className="card">
                <div className="card__background"></div>
                <a className="card__image-wrapper" href="https://egorovagency.com/" target="_blank" rel="noreferrer">
                    <div className="card__image">
                        {/* <div className="card__image-placeholder"></div> */}
                        <img src="/img/portfolio/ea.png" alt="Egorov Agency logo" />
                    </div>
                </a>
                <div className="card__content">
                    <a href="https://webar.egorovagency.com/" className="card__header" target="_blank" rel="noreferrer">WebAr | Egorovagency</a>
                    <div className="card__meta">
                        <span className="card__date">Jun 2020 - Aug 2020</span>
                    </div>
                    <p className="card__paragraph">
                        Company landing about WebAr technology.<br />
                        New sections, CSS animations, Parallax effects, adding on-scroll animations
                    </p>
                </div>
                <div className="card__extra-content">
                    <span>
                        JS(ES6+), Pug, Less, Bootstrap, Locomotive Scroll
                    </span>
                </div>
            </div>

            {/* Biggid */}
            <div className="card">
                <div className="card__background"></div>
                <a className="card__image-wrapper" href="https://widget-v2.herokuapp.com/" target="_blank" rel="noreferrer">
                    <div className="card__image">
                        {/* <div className="card__image-placeholder">
                        DAROO
                    </div> */}
                        <img src="/img/portfolio/biggid.png" alt="Biggid logo" />
                    </div>
                </a>
                <div className="card__content">
                    <a href="https://widget-v2.herokuapp.com/" className="card__header" target="_blank" rel="noreferrer">Biggid Widget</a>,&nbsp;
                    <a href="https://biggid.com" className="card__header" target="_blank" rel="noreferrer">Biggid CRM</a>
                    <div className="card__meta">
                        <span className="card__date">Apr 2020 - Present</span>
                    </div>
                    <p className="card__paragraph">
                        E-commerce booking project.<br />
                        CRM and embeddable widget developing. UI prototyping. Work with open source components: calendars, maps, input masks, pickers, sliders, animations, etc.
                    </p>
                </div>
                <div className="card__extra-content">
                    <span>
                        Vue/Vuex, React, JQuery, Pug, SCSS, Bootstrap, Grunt, Gulp, Webpack
                    </span>
                </div>
            </div>

            {/* Daroo */}
            <div className="card">
                <div className="card__background"></div>
                <a className="card__image-wrapper" href="https://daroo.by" target="_blank" rel="noreferrer">
                    <div className="card__image">
                        {/* <div className="card__image-placeholder">
                        DAROO
                    </div> */}
                        <img src="/img/portfolio/daroo.png" alt="Daroo logo" />
                    </div>
                </a>
                <div className="card__content">
                    <a href="https://daroo.by" className="card__header" target="_blank" rel="noreferrer">Daroo.by</a>
                    <div className="card__meta">
                        <span className="card__date">Mar 2017 - Mar 2020</span>
                    </div>
                    <p className="card__paragraph">
                        Site redesign. New components and pages: main page,
                        catalog, product card, partner card, main menu, blog pages, landing pages. AMP/PWA
                    </p>
                </div>
                <div className="card__extra-content">
                    <span>
                        HTML, CSS, Sass, BEM, Bootstrap, JS (ES5, ES6+), JQuery, Google Maps, Leaflet
                    </span>
                </div>
            </div>

            {/* Domain checker */}
            <div className="card">
                <div className="card__background"></div>
                <a className="card__image-wrapper" href="https://dmn-checker.herokuapp.com/" target="_blank" rel="noreferrer">
                    <div className="card__image">
                        <div className="card__image-placeholder">
                            Domain checker
                        </div>
                    </div>
                    {/* <img src="" alt="..." /> */}
                </a>
                <div className="card__content">
                    <a href="https://dmn-checker.herokuapp.com/" className="card__header" target="_blank" rel="noreferrer">Domain checker</a>
                    <div className="card__meta">
                        <span className="card__date">Jan 2020</span>
                    </div>
                    <p className="card__paragraph">
                        SEO-tool for my colleague.<br />
                        web.archive.org scraper, yandex SERP scraper, saving/reading reports<br />
                        <a href="https://github.com/frantsmn/dmn-checker" target="_blank" rel="noreferrer">GitHub repository</a>
                    </p>
                </div>
                <div className="card__extra-content">
                    <span>
                        Node/Express, Puppeteer, JS(ES6+), Vue/Vuex, Bootstrap
                    </span>
                </div>
            </div>

            {/* Telegram Bot */}
            <div className="card">
                <div className="card__background"></div>
                <a className="card__image-wrapper" href="https://t.me/froghelper_bot" target="_blank" rel="noreferrer">
                    <div className="card__image">
                        {/* <div className="card__image-placeholder">
                        Personal Telegram Bot
                    </div> */}
                        <img src="/img/portfolio/bot.png" alt="Pixel frog" />
                    </div>
                </a>
                <div className="card__content">
                    <a href="https://t.me/froghelper_bot" className="card__header" target="_blank" rel="noreferrer">Personal Telegram Bot</a>
                    <div className="card__meta">
                        <span className="card__date">2019 - Present</span>
                    </div>
                    <p className="card__paragraph">
                        MTS/Beltelecom balance scraper, Currency calculator, Cron events/reminders, Smart bulbs controller (IoT)<br />
                        <a href="ttps://github.com/frantsmn/tbot" target="_blank" rel="noreferrer">GitHub repository</a>
                    </p>
                </div>
                <div className="card__extra-content">
                    <span>
                        Node, Puppeteer, JS/TS, Google Firebase
                    </span>
                </div>
            </div>

            {/* Tetris.js */}
            <div className="card">
                <div className="card__background"></div>
                <a className="card__image-wrapper" href="https://frantsmn.herokuapp.com/" target="_blank" rel="noreferrer">
                    <div className="card__image">
                        {/* <div className="card__image-placeholder">
                        Tetris.js
                    </div> */}
                        <img src="/img/portfolio/tetris.png" alt="Tetris t-block" />
                    </div>
                </a>
                <div className="card__content">
                    <a href="https://frantsmn.herokuapp.com/" className="card__header" target="_blank" rel="noreferrer">Tetris.js</a>
                    <div className="card__meta">
                        <span className="card__date">Dec 2018</span>
                    </div>
                    <p className="card__paragraph">
                        The final project for the course «Developing Web Applications in JavaScript» at IT-Academy<br />
                        <a href="hhttps://github.com/frantsmn/Tetris.js" target="_blank" rel="noreferrer">GitHub repository</a>
                    </p>
                </div>
                <div className="card__extra-content">
                    <span>
                        JS(ES6), JQuery, Swiper, SVG (Figma)
                    </span>
                </div>
            </div>

        </section >
    )
}

export default List;
